import React, { useState } from "react";
import toast from "react-hot-toast";
import api from "../common/apiClient";
import SummaryApi from "../common/SummaryApi";

const RequestVisitModal = ({ open, onClose, propertyId }) => {

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    interest: "",
    message: "",
    visitorsCount: 2, // ✅ default 2
    visitorDate: new Date().toISOString().split("T")[0], // ✅ today date
  });

  // ✅ handle change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // ✅ submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    let newErrors = {};

    if (!form.name) newErrors.name = "Name required";
    if (!form.phone) newErrors.phone = "Phone required";
    if (!form.interest) newErrors.interest = "Select property type";

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    try {
      setLoading(true);

      const res = await api({
        url: SummaryApi.createEnquiry.url,
        method: SummaryApi.createEnquiry.method,
        data: {
          ...form,
          propertyId, // 🔥 important
        },
      });

      if (res?.success || res?.data?.success) {
        toast.success("Visit request submitted successfully");
      }

      // ✅ reset
      setForm({
        name: "",
        phone: "",
        email: "",
        interest: "",
        message: "",
        visitorsCount: 2,
        visitorDate: new Date().toISOString().split("T")[0],
      });

      setErrors({});
      onClose(); // close modal

    } catch (err) {
      console.log(err);
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center px-4">

      <div className="bg-white rounded-2xl w-full max-w-xl p-8 relative">

        {/* CLOSE */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 text-lg"
        >
          ✕
        </button>

        {/* TITLE */}
        <h2 className="text-3xl font-serif text-[#1E293B] mb-3">
          Request a Site Visit
        </h2>

        <p className="text-gray-500 text-sm mb-6">
          Fill out the form below to schedule your personal tour of the plantation hills and experience nature's finest retreat.
        </p>

        <form onSubmit={handleSubmit}>

          {/* NAME */}
          <div className="mb-4">
            <label className="text-sm mb-2 block">Full Name</label>
            <input
              name="name"
              value={form.name}
              onChange={handleChange}
              placeholder="John Doe"
              className={`w-full bg-gray-100 rounded-lg px-4 py-3 ${
                errors.name && "border border-red-500"
              }`}
            />
            {errors.name && (
              <p className="text-red-500 text-xs mt-1">{errors.name}</p>
            )}
          </div>

          {/* PHONE + EMAIL */}
          <div className="grid grid-cols-2 gap-4 mb-4">
            <div>
              <input
                name="phone"
                value={form.phone}
                onChange={handleChange}
                placeholder="+91 00000 00000"
                className={`w-full bg-gray-100 rounded-lg px-4 py-3 ${
                  errors.phone && "border border-red-500"
                }`}
              />
              {errors.phone && (
                <p className="text-red-500 text-xs mt-1">{errors.phone}</p>
              )}
            </div>

            <input
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="john@example.com"
              className="w-full bg-gray-100 rounded-lg px-4 py-3"
            />
          </div>

          {/* PROPERTY */}
          <div className="mb-4">
            <select
              name="interest"
              value={form.interest}
              onChange={handleChange}
              className={`w-full bg-gray-100 rounded-lg px-4 py-3 ${
                errors.interest && "border border-red-500"
              }`}
            >
              <option value="">Property Type</option>
              <option value="Residential">Residential</option>
              <option value="Commercial">Commercial</option>
              <option value="Plantation">Plantation</option>
              <option value="Home">Home</option>
            </select>
            {errors.interest && (
              <p className="text-red-500 text-xs mt-1">{errors.interest}</p>
            )}
          </div>

          {/* DATE */}
          <div className="mb-4">
            <label className="text-sm mb-2 block">Visit Date</label>
            <input
              type="date"
              name="visitorDate"
              value={form.visitorDate}
              onChange={handleChange}
              min={new Date().toISOString().split("T")[0]} // ❌ past disable
              className="w-full bg-gray-100 rounded-lg px-4 py-3"
            />
          </div>

          {/* COUNT */}
          <div className="mb-6">
            <label className="text-sm mb-2 block">Number of Visitors</label>
            <input
              type="number"
              name="visitorsCount"
              value={form.visitorsCount}
              onChange={handleChange}
              min="1"
              className="w-full bg-gray-100 rounded-lg px-4 py-3"
            />
          </div>

          {/* BUTTON */}
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#45A301] text-white py-3 rounded-lg hover:bg-[#3a8a01]"
          >
            {loading ? "Submitting..." : "Request Site Visit →"}
          </button>

        </form>
      </div>
    </div>
  );
};

export default RequestVisitModal;